import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/icons/arrows/arrows-arrow-right-down-line/arrows-arrow-right-down-line.component.js'

const tagName = 'dap-ds-icon-arrow-right-down-line'

/**
 * `dap-ds-icon-arrow-right-down-line`
 * @summary An icon
 * @element dap-ds-icon-arrow-right-down-line
 * @title - ArrowsArrowRightDownLine
 * @group icon
 * @icontype arrows
 *
 * @attribute {number} size - (optional) The width and height in pixels
 * @attribute {boolean} selected - (optional) Sets the icon color via the `fill` attribute
 * @attribute {string} accessibilityTitle - (optional) When using the icon standalone, make it meaningful for accessibility
 * @attribute {boolean} focusable - (optional) If `true` the icon can receive focus
 *
 * @csspart base - The main icon container.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'ArrowsArrowRightDownLine',
})

export default reactWrapper
